import type { CreateDriverInput } from '@chukua/common';
import { useState } from 'react';
import { ApiError } from '../../lib/api';
import { useToast } from '../../lib/use-toast';
import { createDriver } from './drivers.api';
import { useDriverList } from './use-driver-list';

/** The drivers list (`useDriverList`) plus create — a form failure stays inline (CLAUDE.md → Web conventions). */
export function useDrivers() {
  const { state, list, isRefreshing, reload } = useDriverList();
  const [createError, setCreateError] = useState<string | null>(null);
  const [creating, setCreating] = useState(false);
  const toast = useToast();

  /** Returns whether it succeeded, so the drawer knows to close itself — same shape as useCustomers.create. */
  async function create(input: CreateDriverInput): Promise<boolean> {
    setCreateError(null);
    setCreating(true);
    try {
      await createDriver(input);
      await reload();
      toast.success(`${input.name} created`);
      return true;
    } catch (err) {
      setCreateError(
        err instanceof ApiError && err.status === 409
          ? 'A driver with this phone number already exists.'
          : 'Could not create the driver — check the fields and try again.',
      );
      return false;
    } finally {
      setCreating(false);
    }
  }

  return { state, list, isRefreshing, createError, creating, create, resetCreateError: () => setCreateError(null) };
}
